import { Component, EventEmitter, HostListener, OnInit } from '@angular/core';
import saveAs from 'file-saver';
import { Observable, takeUntil } from 'rxjs';
import { BlobResponse } from '../../Models/OtherClasses';
import { BaseBusyableComponent } from '../../Services/BaseBusyableComponent';
import { ConfigService } from '../../Services/ConfigService';
import { ReportsService } from '../../Services/Custom/ServiceReports';

@Component({ 
	selector: 'ReportsShell',
	templateUrl: 'ReportsShell.html',
	
})
export class ReportsShellComponent extends BaseBusyableComponent implements OnInit {
	constructor(
		private configData: ConfigService,
		private myReportsService: ReportsService,
	) {
		super();
	}

	sizeEmitter = new EventEmitter<number>();
	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		this.sizeEmitter.next(window.innerWidth);
	}
	toggleShow() {
		this.showMenu = !this.showMenu;
		this.configData.setSavedSetting('showmenu', 'settingsshell', this.showMenu);
	}
	showMenu = true;

	ngOnInit() {
		this.showMenu = window.innerWidth > 992 || this.configData.getSavedSetting('showmenu', 'settingsshell');
		this.sizeEmitter.subscribe(width => {
			this.showMenu = width > 992 || this.showMenu;
		})
	}

	

}
